import { render, staticRenderFns } from "./cModalViewNotesEdit.vue?vue&type=template&id=4ff3244b"
import script from "./cModalViewNotesEdit.vue?vue&type=script&lang=js"
export * from "./cModalViewNotesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports